import { Component } from '@angular/core';
import { KaMaskeComponent } from './ka-maske.component';

/**
 * Maske "Aufnahmesituation" der KA-Aufnahme: die Felder 12 bis 25 des amtlichen
 * Bogens (Hangneigung bis Bemerkungen), in seiner Reihenfolge.
 *
 * Gezeigt werden ALLE Felder des Blocks, nicht nur die der Kurzaufnahme: Es sind
 * untereinander stehende Zeilen, ein Feld mehr kostet nur eine Zeile. Die Felder
 * der Kurzaufnahme sind Pflicht (siehe `istKaPflichtfeld`).
 *
 * Die Vorlage `ka-felder-maske.component.html` teilt sie mit der
 * Profilkennzeichnung: Beide Blöcke sind heute Zeile für Zeile gleich gebaut, und
 * zwei Kopien derselben Vorlage würden auseinanderlaufen. Die Bauteile bleiben
 * getrennt, weil beide Blöcke mit der Vollaufnahme eigene Eigenheiten bekommen
 * (Feldpaare 17a/17b hier, Wasserstufen dort).
 */
@Component({
	standalone: false,
	selector: 'bp-ka-situation',
	templateUrl: './ka-felder-maske.component.html',
	styleUrls: ['../../detail/hl-area/hl-area.component.css', './ka-maske.component.css'],
})
export class KaSituationComponent extends KaMaskeComponent {
	protected override get maskeId() { return 'situation' as const; }
}
